import React from 'react';
import { BaseLink, BaseLinkProps } from './BaseLink';

export type SubtleLinkProps = Omit<BaseLinkProps, 'color' | 'size'>;

export function SubtleLink({ children, ...props }: SubtleLinkProps) {
    return (
        <BaseLink {...props} color="fiftyFirstShade" size="subtle">
            {children}
        </BaseLink>
    );
}
